// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// Copyright (c) Utrecht University (Department of Information and Computing Sciences)

import axios from "axios";
import * as types from "@/utils/Types";

/**
 * Gets the classroom that the user is in
 * (Policy = student)
 * @returns The classrooms that the user is in
 */
async function getMyClassrooms(): Promise<types.classroom[] | null> {
  console.log("Classrooms");
  try {
    const res = await axios.get<types.classroom[]>(`/Classroom/Classrooms`);
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Gets all the classroom that this user's school has
 * (Policy = teacher)
 * @returns All the classroom that this user's school has
 */
async function getAllClassroomsOfSchool(): Promise<types.classroom[] | null> {
  console.log("Classrooms from school");
  try {
    const res = await axios.get<types.classroom[]>(
      `/Classroom/ClassroomsSchool`
    );
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Gets a list of all the students in a given classroom
 * (Policy = teacher)
 * @param classroomId The ID of the classroom
 * @returns A list of all the students in a given classroom
 */
async function getStudents(
  classroomId: number
): Promise<types.userInfo[] | null> {
  try {
    const res = await axios.get<types.userInfo[]>(
      `/Classroom/Students/${classroomId}`
    );
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Gets a list of all students in all classrooms that the teacher has access to
 * (Policy = teacher)
 * @returns A list of all students of a teacher
 */
async function getAllMyStudents(): Promise<types.userInfo[] | null> {
  try {
    const res = await axios.get<types.userInfo[]>(`/Classroom/Students/All`);
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Gets a list of all bundles belonging to a classroom
 * (Policy = student)
 * @param classroomId The ID of the classroom
 * @returns A list of all bundles belonging to a classroom
 */
async function getBundles(classroomId: number): Promise<types.bundle[] | null> {
  try {
    const res = await axios.get<types.bundle[]>(
      `/Classroom/Bundles/${classroomId}`
    );
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Gets a list of all bundles belonging to all the classrooms where the teacher has access to
 * (Policy = teacher)
 * @returns A list of all bundles of a teacher
 */
async function getAllMyBundles(): Promise<types.bundle[] | null> {
  try {
    const res = await axios.get<types.bundle[]>(`/Classroom/Bundles/All`);
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Add an existing bundle to a class
 * (Policy = teacher)
 * @param classroomId The ID of the classroom
 * @param bundleId The ID of the bundle
 * @returns A HTTP status code
 */
async function addBundle(
  classroomId: number,
  bundleId: number
): Promise<number | null> {
  try {
    const res = await axios.post(
      `/Classroom/AddBundle/${classroomId}/${bundleId}`
    );
    return res.status;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Remove an existing bundle from a class
 * (Policy = teacher)
 * @param classroomId The ID of the classroom
 * @param bundleId The ID of the bundle
 * @returns A HTTP status code
 */
async function removeBundle(
  classroomId: number,
  bundleId: number
): Promise<number | null> {
  try {
    const res = await axios.post(
      `/Classroom/RemoveBundle/${classroomId}/${bundleId}`
    );
    return res.status;
  } catch (err) {
    console.error(err);
    return null;
  }
}

export {
  getMyClassrooms,
  getAllClassroomsOfSchool,
  getStudents,
  getAllMyStudents,
  getBundles,
  getAllMyBundles,
  addBundle,
  removeBundle,
};
